export const MapNumOfMonthsToIndex = (numOfMonths: number) => {
  const defaultValue = 1;
  if (numOfMonths === 1) return 0;
  if (numOfMonths === 3) return 1;
  if (numOfMonths === 6) return 2;
  if (numOfMonths === 12) return 3;
  return defaultValue;
};
